module.exports = __webpack_public_path__ + "assets/img/326301.a024af91.png";